import { Controller } from "@hotwired/stimulus"

// Manages notification permission UI on the profile page.
// Delegates actual subscription logic to window.vptxpPushManager (set up by webpush_controller).
export default class extends Controller {
  static targets = [
    "button",
    "label",
    "iconDefault",
    "iconGranted",
    "iconDenied",
    "deniedSheet",
    "backdrop"
  ]

  static values = {
    labelDefault: String,
    labelGranted: String,
    labelDenied: String
  }

  connect() {
    this._updateState()

    // Watch for permission changes (Chrome supports this)
    if (navigator.permissions) {
      navigator.permissions.query({ name: "notifications" }).then((status) => {
        status.addEventListener("change", () => this._updateState())
      }).catch(() => {
        // Some browsers don't support querying notifications permission
      })
    }
  }

  async enable() {
    const permission = Notification.permission

    if (permission === "granted") return

    if (permission === "denied") {
      this.backdropTarget.classList.remove("hidden")
      this.deniedSheetTarget.classList.remove("hidden")
      return
    }

    // permission === "default" — ask the browser
    if (window.vptxpPushManager) {
      await window.vptxpPushManager.enable()
    } else {
      await Notification.requestPermission()
    }

    this._updateState()
  }

  closeDeniedSheet() {
    this.backdropTarget.classList.add("hidden")
    this.deniedSheetTarget.classList.add("hidden")
  }

  // Private

  _updateState() {
    if (!("Notification" in window)) return

    const permission = Notification.permission

    this.iconDefaultTargets.forEach((el) => el.classList.toggle("hidden", permission !== "default"))
    this.iconGrantedTargets.forEach((el) => el.classList.toggle("hidden", permission !== "granted"))
    this.iconDeniedTargets.forEach((el) => el.classList.toggle("hidden", permission !== "denied"))

    if (this.hasLabelTarget) {
      if (permission === "granted") {
        this.labelTarget.textContent = this.labelGrantedValue
      } else if (permission === "denied") {
        this.labelTarget.textContent = this.labelDeniedValue
      } else {
        this.labelTarget.textContent = this.labelDefaultValue
      }
    }
  }
}
